import { __assign, __awaiter, __generator } from "tslib";
import { createHttpClient } from '@wix/http-client';
;
;
export * from './testkit';
export var createWasabiApi = function (http) {
    var httpClient = createHttpClient();
    return {
        createDashboard: function (addDashboardDto) { return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                data = __assign({}, addDashboardDto);
                return [2 /*return*/, http.post("/apps/wasabi/dashboards", data)];
            });
        }); },
        editDashboard: function (editDashboardDto) { return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                data = __assign({}, editDashboardDto);
                return [2 /*return*/, http.put("/apps/wasabi/dashboards/".concat(editDashboardDto.dashboardId), data)];
            });
        }); },
        getAll: function (_, tenantId) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, http.get("/apps/wasabi/getAll?tenantId=".concat(tenantId))];
            });
        }); },
        delete: function (deleteDashboardDto) { return __awaiter(void 0, void 0, void 0, function () {
            var data, deleteResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = {
                            tenantId: deleteDashboardDto.tenantId,
                        };
                        return [4 /*yield*/, httpClient.delete("https://".concat(deleteDashboardDto.defaultHost, "/apps/wasabi/dashboards/").concat(deleteDashboardDto.dashboardId), { data: data })];
                    case 1:
                        deleteResponse = _a.sent();
                        return [2 /*return*/, deleteResponse.data];
                }
            });
        }); },
        duplicate: function (duplicateDto) { return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                data = {
                    tenantId: duplicateDto.tenantId,
                    title: duplicateDto.title,
                    description: duplicateDto.description,
                    isDefault: duplicateDto.isDefault,
                };
                return [2 /*return*/, http.post("/apps/wasabi/dashboards/".concat(duplicateDto.dashboardId, "/duplicate"), data)];
            });
        }); },
        getAllSchedules: function (tenantId, userEmail) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, http.get("/apps/wasabi/schedules?tenantId=".concat(tenantId, "&userEmail=").concat(userEmail))];
            });
        }); },
    };
};
//# sourceMappingURL=index.js.map